<template>
  <div>
    <!-- 顶部tab切换 -->
    <div class="function-nav">
      <div class="nav-tabs">
        <span v-for="tab in tabs" :key="tab.label" class="tab" :class="{active: activeTab === tab.label}" @click="switchTab(tab)">{{ tab.label }}</span>
      </div>
      <button type="button" class="refresh-btn" @click="onRefresh">刷新</button>
    </div>

    <!-- 用户名单内容区 -->
    <div v-if="activeTab==='用户名单'">
      <!-- 筛选区 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <!-- <div class="form-item">
              <label>注册开始日期：</label>
              <input class="form-input" type="date" v-model="query.startDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>注册结束日期：</label>
              <input class="form-input" type="date" v-model="query.endDate" placeholder="" />
            </div> -->
            <div class="form-item">
              <label>用户姓名：</label>
              <input class="form-input"  v-model="query.userName" placeholder="请输入姓名"/>
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onSearch">搜索</button>
            <button type="button" class="search-btn-green" @click="onCreate">新增</button>
            <button type="button" class="search-btn-green" @click="onDownloadTemplate">下载模板</button>
            <button type="button" class="search-btn-green" @click="openImportModal">批量导入</button>
            <button type="button" class="search-btn-green" @click="openExportModal">批量导出</button>
            <button type="button" class="clear-btn" @click="onClear">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>用户ID</th>
                <th>用户姓名</th>
                <!-- <th>微信号</th> -->
                <th>宿舍号</th>
                <th>联系电话</th>
                <th>所属公司</th>
                <th>注册时间</th>
                <th>下单数量</th>
                <th>违规数量</th>
                <!-- <th>封禁时间</th> -->
                <th>用户状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="11" style="text-align:center;color:#bbb;">数据加载..</td>
              </tr>
              <tr v-else-if="filteredOrders.length === 0">
                <td colspan="11" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(order, index) in filteredOrders" :key="order.userId">
                  <td>{{ (userListPagination.page - 1) * userListPagination.pageSize + index + 1 }}</td>
                  <td>{{ order.userId }}</td>
                  <td>{{ order.employeeName }}</td>
                  <!-- <td>{{ order.wechat }}</td>-->
                  <td>{{ order.dormitory }}</td>
                  <td>{{ order.phone }}</td>
                  <td>{{ order.company }}</td>
                  <td>{{ order.registerTime }}</td>
                  <td>{{ order.orderCount }}</td>
                  <td>{{ order.violationCount }}</td>
                  <!-- <td>{{ order.banDate }}</td> -->
                  <td>
                    <span class="status-badge" :class="getStatusClass(order.status)">
                      {{ order.status }}
                    </span>
                  </td>
                  <td>
                    <button class="btn-edit" @click="onEdit(order)">编辑</button>
                    <button class="btn-delete" @click="onDelete(order)">删除</button>
                    <!-- <button v-if="order.status==='正常'" class="btn-disable" @click="onShowAddBlacklistDialog(order)">禁用</button>
                    <button v-if="order.status==='禁用'" class="btn-enable"  @click="onShowEnableDialog(order)">启用</button> -->
                    <!-- <button v-if="!order.isBlacklisted" type="button" class="btn-add-blacklist" @click="onShowAddBlacklistDialog(order)">加入黑名单</button>
                    <span v-if="order.isBlacklisted" class="status-badge" style="color:#f44336;">已加入黑名单</span> -->
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 分页：服务端分页，基于接口返回total计算 -->
      <div class="pagination" v-if="filteredOrders.length > 0 || userListPagination.total > 0">
        <button class="page-btn" :disabled="userListPagination.page===1" @click="changePage(1)">«</button>
        <button class="page-btn" :disabled="userListPagination.page===1" @click="changePage(userListPagination.page-1)">&lt;</button>
        <!-- <span v-for="p in userListPagination.displayPages" :key="p">
          <button class="page-btn" :class="{active:userListPagination.page===p}" @click="changePage(p)">{{p}}</button>
        </span>  -->
        <span v-for="p in userListPagination.displayPages" :key="p">
          <button v-if="p !== '...'" class="page-btn" :class="{active:userListPagination.page===p}" @click="changePage(p)">{{p}}</button>
          <span v-else class="page-ellipsis">...</span>
        </span>
        <button class="page-btn" :disabled="userListPagination.page===userListPagination.totalPages" @click="changePage(userListPagination.page+1)">&gt;</button>
        <button class="page-btn" :disabled="userListPagination.page===userListPagination.totalPages" @click="changePage(userListPagination.totalPages)">»</button>
        <div class="page-jump">
          <input type="text" v-model.number="userListPagination.pageInput" style="width:50px;"/>
          <button class="jump-btn" @click="jumpPage">跳转</button>
          <span style="margin-left:10px;">共{{userListPagination.total}}条数据</span>
        </div>
      </div>

    </div>

    <!-- 用户行为日志内容区 -->
    <div v-else-if="activeTab==='用户行为日志'">
      <!-- 筛选区 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>员工姓名：</label>
              <select class="form-input" v-model="userLog.userId">
                <option value="">全部</option>
                <option v-for="employee in logEmployeeOptions" :key="employee.userId" :value="employee.userId">
                  {{ employee.employeeName }}(ID: {{ employee.userId }})
                </option>
              </select>
            </div>
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="userLog.startDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="userLog.endDate" placeholder="" />
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onLogSearch">搜索</button>
            <button type="button" class="clear-btn" @click="onLogClear">清空</button>
          </div>
        </form>
      </div>

      <!-- 表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>订单号</th>
                <th>洗衣程序</th>
                <th>洗衣时长</th>
                <th>用户状态</th>
                <th>登录时间</th>
                <th>下单时间</th>
                <th>取衣时间</th>
                <th>是否违规</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="9" style="text-align:center;color:#bbb;">数据加载..</td>
              </tr>
              <tr v-else-if="filteredLogs.length === 0">
                <td colspan="9" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(log, index) in filteredLogs" :key="log.logId">
                  <td>{{ (logPagination.page - 1) * logPagination.pageSize + index + 1 }}</td>
                  <td>{{ log.orderNo }}</td>
                  <td>{{ log.washProgramName }}</td>
                  <td>{{ log.washDurationMinutes }}</td>
                  <td>
                    <span class="status-badge" :class="getStatusClass( log.userStatusName )">
                      {{ log.userStatusName  }}
                    </span>
                  </td>
                  <td>{{ log.loginTime }}</td>
                  <td>{{ log.orderTime }}</td>
                  <td>{{ log.pickupTime }}</td>
                  <td>
                    <span v-if="log.isViolation" class="status-badge" style="background:#f44336;color:#fff;">是</span>
                    <span v-else class="status-badge" style="background:#4caf50;color:#fff;">否</span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination" v-if="filteredLogs.length > 0 || logPagination.total > 0">
        <button class="page-btn" :disabled="logPagination.page===1" @click="logChangePage(1)">«</button>
        <button class="page-btn" :disabled="logPagination.page===1" @click="logChangePage(logPagination.page-1)">&lt;</button>
        <span v-for="p in logPagination.displayPages" :key="p">
          <button class="page-btn" :class="{active:logPagination.page===p}" @click="logChangePage(p)">{{p}}</button>
        </span>
        <button class="page-btn" :disabled="logPagination.page===logPagination.totalPages" @click="logChangePage(logPagination.page+1)">&gt;</button>
        <button class="page-btn" :disabled="logPagination.page===logPagination.totalPages" @click="logChangePage(logPagination.totalPages)">»</button>
        <div class="page-jump">
          <input type="text" v-model.number="logPagination.pageInput" style="width:50px;"/>
          <button class="jump-btn" @click="logJumpPage">跳转</button>
          <span style="margin-left:10px;">共{{logPagination.total}}条数据</span>
        </div>
      </div>
    </div>

    <!-- 黑名单管理内容区 -->
    <div v-else-if="activeTab==='封禁管理'">
      <!-- 筛选区 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>设备编号：</label>
              <select class="form-input" v-model="userBlacklist.deviceNo">
                <option value="">全部</option>
                <option v-for="device in deviceOptions" 
                       :key="device" 
                       :value="device">
                  {{ device }}
                </option>
              </select>
            </div>
            <!-- <div class="form-item">
              <label>违规类型：</label>
              <select class="form-input" v-model="userBlacklist.violationType">
                <option value="">全部</option>
                <option value="PROHIBITED_ITEMS">违禁品</option>
                <option value="TIMEOUT">未取衣</option>
                <option value="OTHER">其他</option>
              </select>
            </div> -->
            <div class="form-item">
              <label>用户姓名：</label>
              <select class="form-input" v-model="userBlacklist.userId">
                <option value="">全部</option>
                <option v-for="employee in blacklistEmployeeOptions" :key="employee.userId" :value="employee.userId">
                  {{ employee.employeeName }}
                </option>
              </select>
            </div>
            <!-- <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="userBlacklist.startDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="userBlacklist.endDate" placeholder="" />
            </div> -->
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onBlacklistSearch">搜索</button>
            <button type="button" class="clear-btn" @click="onBlacklistClear">清空</button>
          </div>
        </form>
      </div>

      <!-- 表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>用户ID</th>
                <th>用户姓名</th>
                <th>设备编号</th>
                <th>所属公司</th>
                <th>注册时间</th>
                <th>联系电话</th>
                <th>封禁天数</th>
                <th>解封时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="10" style="text-align:center;color:#bbb;">数据加载..</td>
              </tr>
              <tr v-else-if="filteredBlacklists.length === 0">
                <td colspan="10" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(blackList, index) in filteredBlacklists" :key="blackList.userId">
                  <td>{{ (blacklistPagination.page - 1) * blacklistPagination.pageSize + index + 1 }}</td>
                  <td>{{ blackList.userId }}</td>
                  <td>{{ blackList.employeeName }}</td>
                  <td>{{ blackList.deviceNo }}</td>
                  <td>{{ blackList.company }}</td>
                  <td>{{ blackList.registerTime }}</td>
                  <td>{{ blackList.phone }}</td>
                  <td>{{ blackList.banDays }}</td>
                  <td>{{ blackList.unbanTime }}</td>
                  <td>
                    <button class="btn-edit" @click="onRemoveBlacklist(blackList)">解除封禁</button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination" v-if="filteredBlacklists.length > 0 || blacklistPagination.total > 0">
        <button class="page-btn" :disabled="blacklistPagination.page===1" @click="blacklistChangePage(1)">«</button>
        <button class="page-btn" :disabled="blacklistPagination.page===1" @click="blacklistChangePage(blacklistPagination.page-1)">&lt;</button>
        <span v-for="p in blacklistPagination.displayPages" :key="p">
          <button class="page-btn" :class="{active:blacklistPagination.page===p}" @click="blacklistChangePage(p)">{{p}}</button>
        </span>
        <button class="page-btn" :disabled="blacklistPagination.page===blacklistPagination.totalPages" @click="blacklistChangePage(blacklistPagination.page+1)">&gt;</button>
        <button class="page-btn" :disabled="blacklistPagination.page===blacklistPagination.totalPages" @click="blacklistChangePage(blacklistPagination.totalPages)">»</button>
        <div class="page-jump">
          <input type="text" v-model.number="blacklistPagination.pageInput" style="width:50px;"/>
          <button class="jump-btn" @click="blacklistJumpPage">跳转</button>
          <span style="margin-left:10px;">共{{blacklistPagination.total}}条数据</span>
        </div>
      </div>
    </div>

    <!-- 新增/编辑用户弹窗 -->
    <div v-if="showDialog" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ isEdit ? '编辑用户' : '新增用户' }}</h3>
          <button class="close-btn" @click="closeDialog" role="button" aria-label="关闭">×</button>
        </div>
        <div class="modal-body">
          <form class="user-form">
            <div class="form-row">

              <div class="form-group">
                <label>用户姓名：</label>
                <input type="text" v-model="currentUser.employeeName" required />
              </div>

             <!-- <div class="form-group">
                <label>微信号：</label>
                <input type="text" v-model="currentUser.wechat" required />
              </div> -->

            </div>

            <div class="form-row">

              <div class="form-group">
                <label>宿舍号：</label>
                <input type="text" v-model="currentUser.dormitory" required />
              </div>
          </div>
            <div class="form-row">

              <!-- <div class="form-group">
                <label>宿舍号：</label>
                <input type="text" v-model="currentUser.dormitory" required />
              </div> -->

              <!-- <div class="form-group">
                <label for="userStatusSelect">服务状态：</label>
                <select id="userStatusSelect" 
                      v-model="currentUser.userstatus" 
                      required>
                  <option value="">请选择</option>
                  <option v-for="status in userStatusOptions" 
                          :key="status.value" 
                          :value="status.value">
                    {{ status.label }}
                  </option>
                </select>
              </div> -->
              <div class="form-group">
                <label>所属公司：</label>
                <input type="text" v-model="currentUser.company" required />
              </div>  
            </div>

            <div class="form-row">

              <div class="form-group">
                <label>联系电话：</label>
                <input type="tel" v-model="currentUser.phone" required />
              </div>

            </div>

            <!-- 编辑时隐藏注册时间/下单/违规数量（接口返回，不可编辑） -->
            <div class="form-row" v-if="isEdit">

              <div class="form-group">
                <label>注册时间：</label>
                <input type="date" v-model="currentUser.registerTime" disabled />
              </div>

              <!-- <div class="form-group">
                <label>下单数量：</label>
                <input type="number" v-model.number="currentUser.orderCount" min="0" disabled />
              </div> -->

            </div>
            <!-- <div class="form-row" v-if="isEdit">

              <div class="form-group">
                <label>违规数量：</label>
                <input type="number" v-model.number="currentUser.violationCount" min="0" disabled />
              </div>

            </div> -->
          </form>
        </div>

        <div class="modal-footer">
          <button class="btn-cancel" @click="closeDialog">取消</button>
          <button class="btn-confirm" @click="saveUser">{{ isEdit ? '保存' : '创建' }}</button>
        </div>
      </div>
    </div>

    <!-- 确认保存弹窗 -->
    <div v-if="showSaveConfirm" class="modal-overlay">
      <div class="modal-content" style="width: 400px;">
        <div class="modal-header">
          <h3>确认保存</h3>
          <button class="close-btn" @click="cancelSave">×</button>
        </div>
        <div class="modal-body">
          <p>{{ isEdit ? '确定要保存对用户信息的修改吗？' : '确定要创建新用户吗？' }}</p>
          <div v-if="isEdit && changeSummary.length > 0" class="change-summary">
            <h4>修改内容：</h4>
            <ul>
              <li v-for="change in changeSummary" :key="change.field">
                {{ change.field }}: {{ change.oldValue }} → {{ change.newValue }}
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="cancelSave">取消</button>
          <button class="btn-confirm" @click="confirmSave">确定</button>
        </div>
      </div>
    </div>
    
    <!-- 启用弹窗 -->
    <div v-if="showUnbanDialog" class="modal-overlay">
      <div class="modal-content" style="width: 500px;">
        <div class="modal-header">
          <h3>启用用户</h3>
          <button class="close-btn" @click="closeUnbanDialog" role="button" aria-label="关闭">×</button>
        </div>
        <div class="modal-body">
          <form class="user-form">

            <div class="form-row">
              <div class="form-group">
                <label>启用理由：</label>
                <input 
                  type="text" 
                  v-model="unbanForm.reason" 
                  placeholder="请输入启用理由"
                  required 
                />
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button class="btn-cancel" @click="closeUnbanDialog">取消</button>
          <button class="btn-confirm" @click="saveUnbanUser">确认启用</button>
        </div>
      </div>
    </div>

    <!-- 禁用弹窗 -->
    <div v-if="showBanDialog" class="modal-overlay">
      <div class="modal-content" style="width: 500px;">
        <div class="modal-header">
          <h3>禁用用户</h3>
          <button class="close-btn" @click="closeBanDialog" role="button" aria-label="关闭">×</button>
        </div>
        <div class="modal-body">
          <form class="user-form">
            <div class="form-row">
              <div class="form-group">
                <label>禁用类型：</label>
                <select v-model="banForm.banType">  
                  <option value="">请选择禁用类型</option>
                  <option value="TEMPORARY">暂时禁用</option>
                  <option value="PERMANENT">永久禁用</option>
                </select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>禁用天数：</label>
                <input 
                  type="number" 
                  v-model.number="banForm.banDays" 
                  :disabled="banForm.banType === 'PERMANENT'"
                  placeholder="请输入禁用天数"
                  min="1"
                  max="365"
                />
                <small v-if="banForm.banType === 'PERMANENT'" style="color: #999; font-size: 12px;">
                  (永久禁用不需要填写天数)
                </small>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>禁用理由：</label>
                <input 
                  type="text" 
                  v-model="banForm.reason" 
                  placeholder="请输入禁用理由"
                  required 
                />
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button class="btn-cancel" @click="closeBanDialog">取消</button>
          <button class="btn-confirm" @click="saveBanUser">确认禁用</button>
        </div>
      </div>
    </div>

    <!-- 批量导入弹窗 -->
    <div v-if="showImportModal" class="modal-overlay">
      <div class="modal-content" style="width: 500px;">
        <div class="modal-header">
          <h3>批量导入用户</h3>
          <button class="close-btn" @click="closeImportModal">×</button>
        </div>
        <div class="modal-body">
          <div style="padding:10px 0;">
            <p>请上传Excel格式的用户数据文件（支持.xlsx/.xls）</p>
            <p style="color:#f5222d;font-size:12px;">注：请先下载模板，按模板格式填写数据</p>
          </div>
          <div style="display: flex; align-items: center; gap: 8px; margin: 15px 0;">
            <input 
              type="file" 
              ref="importFile" 
              accept=".xlsx,.xls" 
              style="flex: 1;" 
              @change="handleFileChange"
            />
            <button 
              v-if="selectedFileName" 
              class="file-delete-btn" 
              @click="clearSelectedFile"
              title="删除已选文件"
              cusor="pointer"
            >×</button>
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" v-model="skipErrors" /> 跳过错误行继续导入
            </label>
            <p style="font-size:12px;color:#666;">勾选后，错误行将被忽略，正确行正常导入</p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="closeImportModal">取消</button>
          <button class="btn-confirm" @click="onBulkImport">开始导入</button>
        </div>
      </div>
    </div>

    <!-- 加入黑名单弹窗 -->
    <div v-if="showAddBlacklistDialog" class="modal-overlay"> 
      <div class="modal-content" style="width: 500px;">
        <div class="modal-header">
          <h3>加入黑名单</h3>
          <button class="close-btn" @click="closeAddBlacklistDialog" role="button" aria-label="关闭">×</button>
        </div>
        <div class="modal-body">
          <form class="user-form">
            <div class="form-row">
              <div class="form-group">
                <label>用户ID：</label>
                <input type="text" v-model="addBlacklistForm.userId" readonly />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>员工姓名：</label>
                <input type="text" v-model="addBlacklistForm.employeeName" readonly />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>违规类型：</label>
                <select v-model="addBlacklistForm.violationType" required>  
                  <option value="">请选择违规类型</option>
                  <option value="prohibited">违禁品</option>
                  <option value="unclaimed">未取衣</option>
                </select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>设备号：</label>
                <input type="text" v-model="addBlacklistForm.deviceNo" required placeholder="请输入设备编号" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>违规原因：</label>
                <input type="text" v-model="addBlacklistForm.reason" required placeholder="请输入违规原因" />
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="closeAddBlacklistDialog">取消</button>
          <button class="btn-confirm" @click="confirmAddBlacklist">确认加入</button>
        </div>
      </div>
    </div> 

  </div>   
</template>

<script>
// 导入所有API接口方法
import {
  listUsers,
  getUserDetail,
  createUser,
  updateUser,
  deleteUser,
  banUser,
  unbanUser,
  importUsers,
  exportUsers,
  downloadUserTemplate,
  getUserBehaviorLogs,
  listBlacklistUsers,
  removeFromBlacklist,
  addToBlacklist
} from '@/api/laundry';

// 状态枚举映射：接口值 ↔ 前端显示值
const statusMap = {
  API_TO_VIEW: {
    NORMAL: '正常',
    PERMANENT_BANNED: '永久封禁',
    TEMP_BANNED: '暂时封禁'
  },
  VIEW_TO_API: {
    '正常': 'NORMAL',
    '永久封禁': 'PERMANENT_BANNED',
    '暂时封禁': 'TEMP_BANNED'
  }
};
// const statusMap = {
//   API_TO_VIEW: {
//     NORMAL: '正常',
//     BLACKLISTED: '封禁中',
//     PERMANENT_BANNED: '永久封禁',
//     TEMP_BANNED: '暂时封禁'
//   },
//   VIEW_TO_API: {
//     '正常': 'NORMAL',
//     '封禁中': 'BLACKLISTED',
//     '永久封禁': 'PERMANENT_BANNED',
//     '暂时封禁': 'TEMP_BANNED'
//   }
// };
// 违规类型枚举映射
const violationTypeMap = {
  PROHIBITED_ITEMS: '违禁物品',
  TIMEOUT: '超时取衣',
  OTHER: '其他'
};

export default {
  name: 'LaundryUserManagement',
  
  data() {
    return {
      // tabs: [
      //   { label: '用户名单' },
      //   { label: '用户行为日志' },
      //   { label: '封禁管理' }
      // ],
      tabs: [
        { label: '用户名单' },
        { label: '封禁管理' }
      ],

      userStatusOptions: [
        { label: '正常', value: 'NORMAL' },
      ],
      // userStatusOptions: [
      //   { label: '正常', value: 'NORMAL' },
      //   { label: '封禁中', value: 'BLACKLISTED' },
      //   { label: '永久封禁', value: 'PERMANENT_BANNED' },
      //   { label: '暂时封禁', value: 'TEMP_BANNED' }
      // ],

      // 筛选选项
      deviceOptions: [], // 黑名单列表中的设备号选项
      violationTypeMap,

      // 员工姓名选项（黑名单管理）- 存储对象数组，包含userId和employeeName
      blacklistEmployeeOptions: [],

      // 角色管理选项接口请求参数
      query: {
        userName: '',
        startDate: '',
        endDate: '',
        pageNo: 1,
        pageSize: 10
      },

      // 用户行为日志选项接口请求参数
      userLog: {
        userId: '',
        startDate: '',
        endDate: '',
        pageNo: 1,
        pageSize: 10
      },

      // 用户黑名单选项接口请求参数
      userBlacklist: {
        deviceNo: '',
        violationType: '',
        userId: '',
        startDate: '',
        endDate: '',
        pageNo: 1,
        pageSize: 10
      },

      // 页面展示数据（接口数据映射后）
      filteredOrders: [],// 筛选后的用户列表
      filteredLogs: [],// 筛选后的用户行为日志列表
      filteredBlacklists: [], // 筛选后的黑名单列表
      allUsers: [], // 所有用户列表（用于下拉选择）
      blacklistedUserIds: new Set(), // 存储已在黑名单的用户ID

      // 独立的分页状态 - 每个标签页都有自己的分页
      userListPagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        displayPages: [],
        pageInput: 1
      },
      logPagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        displayPages: [],
        pageInput: 1
      },
      blacklistPagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        displayPages: [],
        pageInput: 1
      },

      // 弹窗相关
      showDialog: false,// 新增/编辑用户弹窗
      isEdit: false,// 是否为编辑用户
      currentUser: {
        userId: '',
        employeeName: '',
        wechat: '',
        dormitory: '',
        userstatus: '',
        company: '',
        registerTime: '',
        orderCount: 0,
        violationCount: 0,
        phone: '',
        banDate:''
      },
      showSaveConfirm: false,// 确认保存弹窗
      originalUser: null,// 用于保存修改前的用户信息
      changeSummary: [],// 修改摘要

      // 批量导入弹窗
      showImportModal: false,
      skipErrors: true,
      selectedFileName: '', // 新增：存储选中的文件名

      // 批量导出
      exportFileInfo: null,// 导出文件信息

      // 启用弹窗相关
      showUnbanDialog: false,
      unbanForm: {
        userId: '',
        reason: ''
      },

      // 禁用弹窗相关
      showBanDialog: false,
      banForm: {
        userId: '',
        employeeName: '',
        banType: '',
        banDays: '', // 禁用天数
        reason: ''
      },

      // 加入黑名单弹窗相关
      showAddBlacklistDialog: false,
      addBlacklistForm: {
        userId: '',
        employeeName: '',
        violationType: '',
        deviceNo: '',
        reason: ''
      },

      loading: false,
      activeTab: '用户名单',
    };
  },

  watch: {
    activeTab(newTab) {
      this.resetPageParam(newTab);// 切换标签页时重置分页参数
      this.loadTabData(newTab);// 加载指定标签页数据
    },
  },

  computed: {
    // 员工姓名下拉选项（用户行为日志）
    logEmployeeOptions() {
      return this.allUsers.map(user => ({
        userId: user.userId,
        employeeName: user.employeeName
      }));
    }
  },

  created() {
    this.loadTabData(this.activeTab); // 加载指定标签页数据
  },

  // 自定义方法
  methods: {

    // ---------------------- 公共方法相关方法 ----------------------
    // 判断开始日期是否小于结束日期, 且开始日期和结束日期是否在365天之内
    validateDate(startDate, endDate, maxDays = 365) {
      if (!startDate || !endDate) {
        this.showMessage('请选择开始日期和结束日期！', 'error');
        return true;
      }
      if (startDate > endDate) {
        this.showMessage('开始日期不能大于结束日期！', 'error');
        return false;
      }
      const start = new Date(startDate);
      const end = new Date(endDate);
      const diffDays = Math.round((end - start) / (24 * 3600 * 1000));
      if (diffDays > maxDays) {
        this.showMessage(`日期范围不能超过${maxDays}天！`, 'error');
        return false;
      }
      return true;
    },

    // 获取所有数据
    async fetchAllData() {
      this.loading = true;
      try {
        const startTime = new Date().getTime(); // 开始时间戳

        // 等待所有接口调用完成
        await Promise.allSettled([
          this.loadUserList(), //6.1 获取用户名单列表数据
          this.loadUserLogs(), //6.2 获取用户行为列表数据
          this.loadBlacklistList() // 6.3 获取黑名单列表数据
        ]);
        
        const endTime = new Date().getTime();

        console.log(`用户管理模块数据更新完成，耗时：${endTime - startTime}ms`);
        
      } catch (error) {
        console.error('用户管理模块数据更新全局异常:', error);
        this.showMessage('用户管理模块数据更新异常，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

     // 重置分页参数
    resetPageParam(tab) {
      if (tab === '用户名单') {
        this.userListPagination.page = 1;
        this.userListPagination.pageInput = 1;
        this.query.pageNo = 1;
        this.query.pageSize = this.userListPagination.pageSize;
      } else if (tab === '用户行为日志') {
        this.logPagination.page = 1;
        this.logPagination.pageInput = 1;
        this.userLog.pageNo = 1;
        this.userLog.pageSize = this.logPagination.pageSize;
      } else if (tab === '封禁管理') {
        this.blacklistPagination.page = 1;
        this.blacklistPagination.pageInput = 1;
        this.userBlacklist.pageNo = 1;
        this.userBlacklist.pageSize = this.blacklistPagination.pageSize;
      }
    },

    // 同步页码到请求参数
    syncPageNoToQuery() {
      if (this.activeTab === '用户名单') {
        this.query.pageNo = this.userListPagination.page;
        this.query.pageSize = this.userListPagination.pageSize;
        
      } else if (this.activeTab === '用户行为日志') {
        this.userLog.pageNo = this.logPagination.page;
        this.userLog.pageSize = this.logPagination.pageSize;
       
      } else if (this.activeTab === '封禁管理') {
        this.userBlacklist.pageNo = this.blacklistPagination.page;
        this.userBlacklist.pageSize = this.blacklistPagination.pageSize;
        
      }
    },

    // 加载指定标签页数据
    async loadTabData(tab) {
      this.loading = true;
      try {
        switch (tab) {
          case '用户名单':
            await this.loadUserList();
            break;
          case '用户行为日志':
            await this.loadUserLogs();
            break;
          case '封禁管理':
            await this.loadBlacklistList();
            break;
        }
      } catch (error) {
        console.error(`加载${tab}数据失败:`, error);
        this.showMessage(`加载${tab}数据失败`, 'error');
      } finally {
        this.loading = false;
        this.updatePagination(tab);
      }
    },
    
    // 刷新数据
    async onRefresh() {
      this.loading = true;
      try {
        await this.loadTabData(this.activeTab);
        this.showMessage('数据刷新成功', 'success');
      } catch (error) {
        this.showMessage('数据刷新失败', 'error');
      } finally {
        this.loading = false;
      }
    },

    // 切换标签
    switchTab(tab) {
      this.activeTab = tab.label;
    },

    // 更新分页计算
    updatePagination(tab) {
      let pagination;
      if (tab === '用户名单') {
        pagination = this.userListPagination;
      } else if (tab === '用户行为日志') {
        pagination = this.logPagination;
      } else if (tab === '封禁管理') {
        pagination = this.blacklistPagination;
      } else {
        return;
      }
      
      pagination.totalPages = Math.ceil(pagination.total / pagination.pageSize) || 1;
      if (pagination.page > pagination.totalPages) {
        pagination.page = pagination.totalPages;
        this.syncPageNoToQuery();
      }
      this.updateDisplayPages(tab);
    },


    // 更新显示页码
    updateDisplayPages(tab) {
      let pagination;
      if (tab === '用户名单') {
        pagination = this.userListPagination;
      } else if (tab === '用户行为日志') {
        pagination = this.logPagination;
      } else if (tab === '封禁管理') {
        pagination = this.blacklistPagination;
      } else {
        return;
      }
      
      const total = pagination.totalPages;
      const current = pagination.page;
      const pages = [];
      
      if (total <= 7) {
        // 总页数小于等于7，全部显示
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        // 总页数大于7，使用省略号
        if (current <= 4) {
          // 当前页靠近开头
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 3) {
          // 当前页靠近结尾
          pages.push(1);
          pages.push('...');
          for (let i = total - 4; i <= total; i++) {
            pages.push(i);
          }
        } else {
          // 当前页在中间
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        }
      }
      
      pagination.displayPages = pages;
    },
    // updateDisplayPages(tab) {
    //   let pagination;
    //   if (tab === '用户名单') {
    //     pagination = this.userListPagination;
    //   } else if (tab === '用户行为日志') {
    //     pagination = this.logPagination;
    //   } else if (tab === '封禁管理') {
    //     pagination = this.blacklistPagination;
    //   } else {
    //     return;
    //   }
      
    //   const pages = [];
    //   const maxDisplay = 5;
    //   let start = Math.max(1, pagination.page - Math.floor(maxDisplay / 2));
    //   let end = Math.min(pagination.totalPages, start + maxDisplay - 1);
    //   if (end - start + 1 < maxDisplay) {
    //     start = Math.max(1, end - maxDisplay + 1);
    //   }
    //   for (let i = start; i <= end; i++) {
    //     pages.push(i);
    //   }
    //   pagination.displayPages = pages;
    // },

    // 取消保存
    cancelSave() {
      this.showSaveConfirm = false;
    },

    // 关闭所有弹窗
    closeAllDialogs() {
      this.showDialog = false;
      this.showSaveConfirm = false;
      this.showBanDialog = false;
      this.currentUser = {
        userId: '',
        employeeName: '',
        wechat: '',
        dormitory: '',
        userstatus: '',
        company: '',
        registerTime: '',
        orderCount: 0,
        violationCount: 0,
        phone: ''
      };
      this.originalUser = null;
      this.changeSummary = [];
      this.banForm = {
        userId: '',
        employeeName: '',
        banType: '',
        banDays: 30,
        reason: ''
      };
    },

    // 关闭弹窗
    closeDialog() {
      this.showDialog = false;
      this.closeAllDialogs();
    },

    // 消息提示
    showMessage(message, type = 'success') {
      if (type === 'success') {
        alert('✅ ' + message);
      } else {
        alert('❌ ' + message);
      }
    },

    // ---------------------- 用户管理相关方法 ----------------------
    // 映射用户列表：接口字段 → 前端字段
    mapUserList(list) {
      return list.map(item => ({
        userId: item.userId,
        employeeName: item.userName,
        wechat: item.wechatId,
        dormitory: item.dormitoryNo,
        status: statusMap.API_TO_VIEW[item.userStatus] || '正常',// 状态映射
        company: item.companyName,
        registerTime: item.registerDate,
        orderCount: item.orderCount || 0,
        violationCount: item.violationCount || 0,
        phone: item.mobile,
        banDate: item.banDate || '-',
        isBlacklisted: this.blacklistedUserIds.has(item.userId) // 标记是否在黑名单中
      }));
    },

    // 状态样式类
    getStatusClass(status) {
      const statusClassMap = {
        '正常': 'status-normal',
        '暂时封禁': 'status-temp-banned',
        '永久封禁': 'status-permanent-banned',
        '封禁中': 'status-blacklist',
      };
      return statusClassMap[status] || 'status-normal';
    },

    // 新用户弹窗
    onCreate() {
      this.isEdit = false;
      this.currentUser = {
        userId: '',
        employeeName: '',
        
        dormitory: '',
        userstatus: '正常',
        company: '',
        registerTime: new Date().toISOString().slice(0, 10),
        orderCount: 0,
        violationCount: 0,
        phone: ''
      };
      this.originalUser = null; // 用于保存修改前的用户信息
      this.showDialog = true; // 显示弹窗
    },

    // 保存用户弹窗
    saveUser() {
      if (!this.validateForm()) return; // 表单验证
      if (this.isEdit) {
        this.generateChangeSummary();// 生成修改摘要
        this.showSaveConfirm = true;
      } else {
        this.confirmSave();// 直接创建
      }
    },

    // 表单输入验证
    validateForm() {
      //const { employeeName, wechat, dormitory, company, phone } = this.currentUser;
      const { employeeName,  dormitory, company, phone } = this.currentUser;
      if (!employeeName.trim()) {
        this.showMessage('请输入员工姓名', 'error');
        return false;
      }
      // if (!wechat.trim()) {
      //   this.showMessage('请输入微信号', 'error');
      //   return false;
      // }
      if (!dormitory.trim()) {
        this.showMessage('请输入宿舍号', 'error');
        return false;
      }
      if (!company.trim()) {
        this.showMessage('请输入所属公司', 'error');
        return false;
      }
      if (!phone.trim()) {
        this.showMessage('请输入联系电话', 'error');
        return false;
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(phone)) {
        this.showMessage('请输入正确的11位手机号码', 'error');
        return false;
      }
      return true;
    },

    // 生成修改摘要
    generateChangeSummary() {
      this.changeSummary = [];
      const fields = [
        { key: 'employeeName', name: '员工姓名' },
        { key: 'wechat', name: '微信号' },
        { key: 'dormitory', name: '宿舍号' },
        { key: 'userstatus', name: '用户状态' },
        { key: 'company', name: '所属公司' },
        { key: 'phone', name: '联系电话' }
      ];
      fields.forEach(field => {
        const oldValue = this.originalUser[field.key];
        const newValue = this.currentUser[field.key];
        if (oldValue !== newValue) {
          this.changeSummary.push({
            field: field.name,
            oldValue: oldValue || '空',
            newValue: newValue || '空'
          });
        }
      });
    },

    // 切换页码（用户名单）
    changePage(newPage) {
      if (newPage >= 1 && newPage <= this.userListPagination.totalPages) {
        this.userListPagination.page = newPage;
        this.userListPagination.pageInput = newPage;
        this.syncPageNoToQuery();
        this.loadUserList();
      }
    },

    // 页码跳转（用户名单）
    jumpPage() {
      let targetPage = parseInt(this.userListPagination.pageInput);
      if (isNaN(targetPage) || targetPage < 1) targetPage = 1;
      else if (targetPage > this.userListPagination.totalPages) targetPage = this.userListPagination.totalPages;
      this.changePage(targetPage);
    },

    // 搜索方法（用户名单）
    onSearch() {
      this.userListPagination.page = 1;
      this.userListPagination.pageInput = 1;
      this.syncPageNoToQuery();
      this.loadUserList();
      // if (this.validateDate(this.query.startDate, this.query.endDate)) {
      //   this.syncPageNoToQuery();
      //   this.loadUserList();
      // }
      // else {
      //   this.query = { startDate: '', endDate: ''};
      // }
    },

    // 清空筛选（用户名单）
    onClear() {
      this.query = { userName: '', startDate: '', endDate: '', pageNo: 1, pageSize: this.userListPagination.pageSize };
      this.userListPagination.page = 1;
      this.userListPagination.pageInput = 1;
      this.loadUserList();
    },

    // 打开批量导入弹窗
    openImportModal() {
      this.showImportModal = true;
      this.skipErrors = false;
      this.$refs.importFile.value = ''; // 重置文件选择
    },

    // 关闭批量导入弹窗
    closeImportModal() {
      this.showImportModal = false;
      this.selectedFileName = ''; // 新增：重置文件名
      this.$refs.importFile.value = ''; // 重置文件选择
    },

    // 处理文件选择变化
    handleFileChange(event) {
      const file = event.target.files[0];
      this.selectedFileName = file ? file.name : '';
    },

    // 清除已选文件
    clearSelectedFile() {
      this.$refs.importFile.value = ''; // 清空文件输入
      this.selectedFileName = ''; // 清空文件名记录
    },

    // ------- 启用用户相关方法 -----
    // 显示启用弹窗
    onShowEnableDialog(data) {
      this.unbanForm = {
        userId: data.userId,  
        reason: ''
      };
      this.showUnbanDialog = true;
    },

    // 关闭启用弹窗
    closeUnbanDialog() {
      this.showUnbanDialog = false;
      this.unbanForm = {
        userId: '',
        reason: ''
      };  
    },

    // 启用表单验证
    validateUnbanForm() {
      if (!this.unbanForm.reason.trim()) {
        this.showMessage('请输入启用理由', 'error');
        return false;
      }
      return true;
    },


    // -------- 禁用用户相关方法 -------
    // 显示禁用弹窗
    onShowBanDialog(data) {
      this.banForm = {
        userId: data.userId,
        employeeName: data.employeeName,
        banType: 'TEMPORARY', // 默认临时禁用
        banDays: '', 
      };
      this.showBanDialog = true;
    },

    // 关闭禁用弹窗
    closeBanDialog() {
      this.showBanDialog = false;
      this.banForm = {
        userId: '',
        employeeName: '',
        banType: '',
        banDays: '',
        reason: ''
      };
    },

    //禁用表单验证
    validateBanForm() {
      // 验证表单
      if (!this.banForm.banType) {
        this.showMessage('请选择禁用类型', 'error');
        return false;
      }
      
      if (!this.banForm.reason.trim()) {
        this.showMessage('请输入禁用理由', 'error');
        return false;
      }
      
      // 临时禁用需要验证天数
      if (this.banForm.banType === 'TEMPORARY') {
        if (!this.banForm.banDays || this.banForm.banDays < 1) {
          this.showMessage('请输入有效的禁用天数（1-365天）', 'error');
          return false;
        }
        if (this.banForm.banDays > 365) {
          this.showMessage('禁用天数不能超过365天', 'error');
          return false;
        }
      }
      return true;
    },

    // ---------------------- 行为日志相关方法 ----------------------
    // 映射行为日志：接口字段 → 前端字段
    mapLogList(list) {
      return list.map(item => ({
        logId: item.logId,
        orderNo: item.orderNo,
        washProgramName: item.washProgramName,
        washDurationMinutes: `${item.washDurationMinutes || 0}分钟`,
        userStatusName: item.userStatusName,
        loginTime: item.loginTime,
        orderTime: item.orderTime,
        pickupTime: item.pickupTime,
        isViolation: item.isViolation
        
      }));
    },

    // 搜索方法（行为日志）
    onLogSearch() {
      this.logPagination.page = 1;
      this.logPagination.pageInput = 1;
      this.syncPageNoToQuery();
      this.loadUserLogs();
      // if (this.validateDate(this.userLog.startDate, this.userLog.endDate)) {
      //   this.syncPageNoToQuery();
      //   this.loadUserLogs();
      // }
      // else {
      //   this.userLog = {  userId: '', startDate: '', endDate: ''};
      // }
    },

    // 清空筛选（行为日志）
    onLogClear() {
      this.userLog = { userId: '', startDate: '', endDate: '', pageNo: 1, pageSize: this.logPagination.pageSize };
      this.logPagination.page = 1;
      this.logPagination.pageInput = 1;
      this.loadUserLogs();
    },

    // 切换页码（用户行为日志）
    logChangePage(newPage) {
      if (newPage >= 1 && newPage <= this.logPagination.totalPages) {
        this.logPagination.page = newPage;
        this.logPagination.pageInput = newPage;
        this.syncPageNoToQuery();
        this.loadUserLogs();
      }
    },

    // 页码跳转（用户行为日志）
    logJumpPage() {
      let targetPage = parseInt(this.logPagination.pageInput);
      if (isNaN(targetPage) || targetPage < 1) targetPage = 1;
      else if (targetPage > this.logPagination.totalPages) targetPage = this.logPagination.totalPages;
      this.logChangePage(targetPage);
    },

    // ---------------------- 黑名单管理相关方法 ----------------------
    // 映射黑名单列表：接口字段 → 前端字段
    mapBlacklistList(list) {
      return list.map(item => ({
        userId: item.userId,
        employeeName: item.username,
        deviceNo: item.boundDeviceNo,
        company: item.companyName,
        registerTime: item.registerDate,
        phone: item.mobile,
        banDays: item.banDays || '-',
        unbanTime: item.unbanTime || '-',
        canAddToBlacklist: item.canAddToBlacklist || false
      }));
    },

    // 搜索方法（黑名单）
    onBlacklistSearch() {
      this.blacklistPagination.page = 1;
      this.blacklistPagination.pageInput = 1;
      this.syncPageNoToQuery();
      this.loadBlacklistList();
      // if (this.validateDate(this.userBlacklist.startDate, this.userBlacklist.endDate)) {
      //   this.syncPageNoToQuery();
      //   this.loadBlacklistList();
      // }
      // else {
      //   this.userBlacklist = { deviceNo: '', violationType: '', userId: '', startDate: '', endDate: ''};
      // }
    },

    // 清空筛选（黑名单）
    onBlacklistClear() {
      this.userBlacklist = { 
        deviceNo: '', 
        violationType: '', 
        userId: '', 
        startDate: '', 
        endDate: '', 
        pageNo: 1, 
        pageSize: this.blacklistPagination.pageSize 
      };
      this.blacklistPagination.page = 1;
      this.blacklistPagination.pageInput = 1;
      this.loadBlacklistList();
    },

    // 切换页码（黑名单管理）
    blacklistChangePage(newPage) {
      if (newPage >= 1 && newPage <= this.blacklistPagination.totalPages) {
        this.blacklistPagination.page = newPage;
        this.blacklistPagination.pageInput = newPage;
        this.syncPageNoToQuery();
        this.loadBlacklistList();
      }
    },

    // 页码跳转（黑名单管理）
    blacklistJumpPage() {
      let targetPage = parseInt(this.blacklistPagination.pageInput);
      if (isNaN(targetPage) || targetPage < 1) targetPage = 1;
      else if (targetPage > this.blacklistPagination.totalPages) targetPage = this.blacklistPagination.totalPages;
      this.blacklistChangePage(targetPage);
    },

    // ---------------------- 加入黑名单弹窗相关方法 ----------------------
    // 显示加入黑名单弹窗
    onShowAddBlacklistDialog(row) {
      this.addBlacklistForm = {
        userId: row.userId,
        employeeName: row.employeeName,
        violationType: '',
        deviceNo: '',
        reason: ''
      };
      this.showAddBlacklistDialog = true;
    },

    // 关闭加入黑名单弹窗
    closeAddBlacklistDialog() {
      this.showAddBlacklistDialog = false;
      this.addBlacklistForm = {
        userId: '',
        employeeName: '',
        violationType: '',
        deviceNo: '',
        reason: ''
      };
    },

    // 验证加入黑名单表单
    validateAddBlacklistForm() {
      if (!this.addBlacklistForm.violationType) {
        this.showMessage('请选择违规类型', 'error');
        return false;
      }
      if (!this.addBlacklistForm.deviceNo.trim()) {
        this.showMessage('请输入设备号', 'error');
        return false;
      }
      if (!this.addBlacklistForm.reason.trim()) {
        this.showMessage('请输入违规原因', 'error');
        return false;
      }
      return true;
    },

    // 确认加入黑名单
    async confirmAddBlacklist() {
      if (!this.validateAddBlacklistForm()) return;
      
      this.loading = true;
      try {
        const response = await addToBlacklist({
          userId: this.addBlacklistForm.userId,
          violationType: this.addBlacklistForm.violationType,
          deviceNo: this.addBlacklistForm.deviceNo,
          reason: this.addBlacklistForm.reason
        });
        const res = response.data;
        if (res.code === 0 && res.data.success) {
          this.showMessage('用户加入黑名单成功', 'success');
          this.closeAddBlacklistDialog();
          // 更新黑名单用户ID集合
          this.blacklistedUserIds.add(this.addBlacklistForm.userId);
          // 刷新列表
          this.loadBlacklistList();
          this.loadUserList();
          this.isBlacklisted = true;
        } else {
          throw new Error(res.message || '加入黑名单失败');
        }
      } catch (error) {
        console.error('加入黑名单失败:', error);
        this.showMessage('加入黑名单失败', 'error');
      } finally {
        this.loading = false;
      }
    },

    // ---------------------- 接口获取数据相关方法 ----------------------
    // 6.1 加载用户名单（对接listUsers接口）
    async loadUserList() {
      try {
        const params = {
          ...this.query,// 请求参数
          startDate: this.query.startDate ? this.query.startDate.replace(/-/g, '/') : '',
          endDate:  this.query.endDate ? this.query.endDate.replace(/-/g, '/') : ''
        };
        
        const response = await listUsers(params);
        const res = response.data;

        if (res.code === 0) {
          const { list, total, pageNo, pageSize } = res.data;
          this.userListPagination.total = total;
          this.userListPagination.page = pageNo;
          this.userListPagination.pageSize = pageSize;
          // 接口数据映射到前端字段
          if (list && list.length > 0) {
            this.filteredOrders = this.mapUserList(list);
            this.allUsers = this.filteredOrders; // 保存所有用户用于下拉
          } else {
            this.filteredOrders = [];
            this.allUsers = [];
          }
        } else {
          throw new Error(res.message || '获取用户名单失败');
        }
      } catch (error) {
        console.error('加载用户名单失败:', error);
        this.showMessage('加载用户名单失败', 'error');
        this.filteredOrders = [];
        this.allUsers = [];
      }
    },

    // 6.2 用户详情 编辑回显（对接getUserDetail接口）
    async onEdit(data) {
      if (!data.userId) return false;
      try {
        const response = await getUserDetail({ userId: data.userId });
        const res = response.data;
        console.log('用户详情数据（编辑回显）：', res);
        if (res.code === 0 && res.data) {
          const data = res.data;
          this.currentUser = {
            userId: data.userId,
            employeeName: data.employeeName,
            wechat: data.wechatId,
            dormitory: data.dormitoryNo,
            userstatus: data.userStatus,
            company: data.companyName,
            registerTime: data.registerDate,
            orderCount: data.orderCount || 0,
            violationCount: data.violationCount || 0,
            phone: data.mobile
          };
          
          this.originalUser = { ...this.currentUser };
          this.isEdit = true;
          this.showDialog = true;
        } else {
          throw new Error(res.message || '获取用户详情失败');
        }
      } catch (error) {
        console.error('编辑用户失败:', error);
        this.showMessage('获取用户详情失败', 'error');
      } finally {
        this.loading = false;
      }
    },
    
    // 6.3 确认保存用户：新增+编辑
    async confirmSave() {
      try {
        const apiData = {
          userName: this.currentUser.employeeName,
          dormitoryNo: this.currentUser.dormitory,
          userStatus: "NORMAL",
          companyName: this.currentUser.company,
          mobile: this.currentUser.phone
        };
        //  const apiData = {
        //   userName: this.currentUser.employeeName,
        //   wechatId: this.currentUser.wechat,
        //   dormitoryNo: this.currentUser.dormitory,
        //   userStatus: "NORMAL",
        //   companyName: this.currentUser.company,
        //   mobile: this.currentUser.phone
        // };
        if (this.isEdit) {
          const response = await updateUser({ userId: this.currentUser.userId, ...apiData });
          const res = response.data;
          if (res.code === 0 && res.data.success) {
            this.showSaveConfirm = false;// 关闭确认弹窗
            this.showDialog = false;// 关闭弹窗
            this.showMessage('用户编辑成功','success');
            // 新增用户1秒后刷新列表数据
            setTimeout(() => {
              this.loadUserList();// 刷新列表数据
            }, 1000);
          } else {
            throw new Error(res.message || '编辑失败');
          }
        } else {
          const response = await createUser(apiData);
          const res = response.data;
          if (res.code === 0 && res.data.success) {
            this.showSaveConfirm = false;// 关闭确认弹窗
            this.showDialog = false;// 关闭弹窗
            this.showMessage('用户新增成功','success');    
            // 新增用户1秒后刷新列表数据
            setTimeout(() => {
              this.loadUserList();// 刷新列表数据
            }, 1000);
          } else {
            throw new Error(res.message || '新增失败');
          } 
        }
      } catch (error) {
        console.error('保存用户失败:', error);
        this.showMessage(this.isEdit ? '用户编辑失败' : '用户新增失败', 'error');
      } finally {
        this.loading = false;
      }
    },

    // 6.4 删除用户 
    async onDelete(data) {
      if (!confirm(`确定要删除用户【${data.employeeName}】吗？删除后不可恢复！`)) return;
      try {
        const response = await deleteUser({ userId: data.userId });
        const res = response.data;
        if (res.code === 0 && res.data.success) {
          this.showMessage('用户删除成功', 'success');
          // 1秒后刷新列表数据
          setTimeout(() => {
            this.loadUserList();
          }, 1000);
        } else {
          throw new Error(res.message || '用户删除失败');
        }
      } catch (error) {
        console.error('删除用户失败:', error);
        this.showMessage('用户删除失败', 'error');
      } finally {
        this.loading = false;
      }
    },

    // 6.5 启用用户
    async saveUnbanUser() {
      if (!this.validateUnbanForm()) return;
      try {
        const response = await unbanUser({ userId: this.unbanForm.userId, reason: this.unbanForm.reason });
        const res = response.data;
        if (res.code === 0 && res.data.success) {
          this.showMessage('用户启用成功');
          this.closeUnbanDialog();

          // 1秒后刷新列表数据
          setTimeout(() => {
            this.loadUserList();
          }, 1000);

        } else {
          throw new Error(res.message || '用户启用失败');
        }
      } catch (error) {
        console.error('用户启用失败:', error);
        this.showMessage('用户启用失败', 'error');
      } finally {
        this.loading = false;
      }
    },

    // 6.6 禁用用户(暂时封禁/永久封禁)
    async saveBanUser() {
      // 验证表单
      var isBanFormValid = this.validateBanForm();
      if (!isBanFormValid) return;
      // 禁用用户
      try {
        const banData = {
          userId: this.banForm.userId,
          reason: this.banForm.reason
        };
        
        // 如果是临时禁用，添加banDays参数
        if (this.banForm.banType === 'TEMPORARY') {
          banData.banDays = this.banForm.banDays;
        }
        if (this.banForm.banType === 'PERMANENT') {
          banData.banDays = 0; // 禁用永久
        }
        
        const response = await banUser(banData);
        const res = response.data;
        
        if (res.code === 0 && res.data.success) {
          const banTypeText = this.banForm.banType === 'TEMPORARY' ? '临时' : '永久';
          this.showMessage(`用户${banTypeText}禁用成功`, 'success');
          this.closeBanDialog();
          
          // 1秒后刷新列表数据
          setTimeout(() => {
            this.loadUserList();
          }, 1000);

        } else {
          throw new Error(res.message || '用户禁用失败');
        }
      } catch (error) {
        console.error('禁用用户失败:', error);
        this.showMessage('用户禁用失败', 'error');
      } finally {
        this.loading = false;
      }
    },

    // 6.7 用户行为日志（对接getUserBehaviorLogs接口）
    async loadUserLogs() {
      try {
        const params = {
          ...this.userLog,
          startDate: this.userLog.startDate ? this.userLog.startDate.replace(/-/g, '/') : '',
          endDate: this.userLog.endDate ? this.userLog.endDate.replace(/-/g, '/') : ''
        };
        const response = await getUserBehaviorLogs(params);
        const res = response.data;
        if (res.code === 0) {
          const { list, total, pageNo, pageSize } = res.data;
          this.logPagination.total = total;
          this.logPagination.page = pageNo;
          this.logPagination.pageSize = pageSize;
          console.log('用户行为日志数据：', list);
          if (list && list.length > 0) {
            this.filteredLogs = this.mapLogList(list);
          } else {
            this.filteredLogs = [];
          }
        } else {
          throw new Error(res.message || '获取用户行为日志失败');
        }
      } catch (error) {
        console.error('加载用户行为日志失败:', error);
        this.showMessage('加载用户行为日志失败', 'error');
        this.filteredLogs = [];
      }
    },

    // 6.8 加载黑名单列表（对接listBlacklistUsers接口）
    async loadBlacklistList() {
      try {
        const params = {
          ...this.userBlacklist,
          userId: this.userBlacklist.userId,
          startDate: this.userBlacklist.startDate ? this.userBlacklist.startDate.replace(/-/g, '/') : '',
          endDate: this.userBlacklist.endDate ? this.userBlacklist.endDate.replace(/-/g, '/') : ''
        };
        const response = await listBlacklistUsers(params);
        const res = response.data;
        if (res.code === 0) {
          const { list, total, pageNo, pageSize } = res.data;
          this.blacklistPagination.total = total;
          this.blacklistPagination.page = pageNo;
          this.blacklistPagination.pageSize = pageSize;
          
          // 从黑名单列表中提取筛选项
          if (list && list.length > 0) {
            // 提取设备号选项（去重）
            const deviceSet = new Set();
            const employeeMap = new Map(); // 用于去重并保留userId和employeeName的映射
            
            list.forEach(item => {
              if (item.boundDeviceNo) {
                deviceSet.add(item.boundDeviceNo);
              }
              if (item.userId && item.username) {
                employeeMap.set(item.userId, {
                  userId: item.userId,
                  employeeName: item.username
                });
              }
            });
            
            this.deviceOptions = [...deviceSet];
            this.blacklistEmployeeOptions = [...employeeMap.values()];
            
            // 更新黑名单用户ID集合
            this.blacklistedUserIds = new Set(list.map(item => item.userId));
            
            // 映射表格数据
            this.filteredBlacklists = this.mapBlacklistList(list);
          } else {
            this.deviceOptions = [];
            this.blacklistEmployeeOptions = [];
            this.blacklistedUserIds = new Set();
            this.filteredBlacklists = [];
          }
        } else {
          throw new Error(res.message || '获取黑名单列表失败');
        }
      } catch (error) {
        console.error('加载黑名单列表失败:', error);
        this.showMessage('加载黑名单列表失败', 'error');
        this.deviceOptions = [];
        this.blacklistEmployeeOptions = [];
        this.blacklistedUserIds = new Set();
        this.filteredBlacklists = [];
      }
    },

    // 6.9 移除黑名单
    async onRemoveBlacklist(row) {
      if (!confirm(`确定要将用户【${row.employeeName}(ID:${row.userId})】解除封禁吗？`)) return;
      this.loading = true;
      try {
        const response = await removeFromBlacklist({
          userId: row.userId,
          reason: '后台手动移出'
        });
        const res = response.data;
        if (res.code === 0 && res.data.success) {
          this.showMessage('用户解除封禁成功', 'success');
          // 更新黑名单用户ID集合
          this.blacklistedUserIds.delete(row.userId);
          this.loadBlacklistList();
          this.loadUserList();
        } else {
          throw new Error(res.message || '解除封禁失败');
        }
      } catch (error) {
        console.error('解除封禁失败:', error);
        this.showMessage('解除封禁失败', 'error');
      } finally { 
        this.loading = false;
      }
    },

    // 6.10 批量导入用户(**)
    async onBulkImport() {
      const file = this.$refs.importFile?.files[0];
      if (!file) {
        this.showMessage('请选择要导入的Excel文件', 'error');
        return;
      }
      // 验证文件格式
      const ext = file.name.split('.').pop().toLowerCase();
      if (!['xlsx', 'xls'].includes(ext)) {
        this.showMessage('请上传.xlsx或.xls格式的Excel文件', 'error');
        return;
      }
      try {
        // 构建form-data（对接批量导入接口的multipart/form-data）
        const formData = new FormData();
        formData.append('file', file);
        formData.append('skip_errors', this.skipErrors);
        const respose = await importUsers(formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        const res = respose.data;
        if (res.success) {
          this.showMessage(`批量导入成功：成功${res.success_count}条，跳过${res.skip_count}条`, 'success');
          this.closeImportModal();
          await this.loadUserList();
        } else {
          this.showMessage(`批量导入部分成功：成功${res.success_count}条，失败${res.skip_count}条\n${res.errors.join('\n')}`, 'error');
        }
      } catch (error) {
        console.error('批量导入失败:', error);
        this.showMessage('批量导入失败：' + (error.message || '服务器错误'), 'error');
      }
    },

    // 6.11 下载导入模板(**)
    async onDownloadTemplate() {
      try {
        const res = await downloadUserTemplate({
          responseType: 'blob' // 二进制流
        });
        // 生成下载链接
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'user_import_template.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
        this.showMessage('模板下载成功', 'success');
      } catch (error) {
        console.error('下载模板失败:', error);
        this.showMessage('模板下载失败', 'error');
      }
    },

    // 6.12 导出用户(**)
    async openExportModal() { 
      const postData = {
        startDate: "",
        endDate: "",
      };
      const response = await exportUsers(postData);
      const res = response.data;
      if (res.code === 0 && res.data) {
        this.exportFileInfo = res.data;
        this.showMessage('用户名单导出成功！', 'success');
        window.open(this.exportFileInfo.fileUrl, '_blank');
      }else {
        this.showMessage(res?.message || '用户名单导出失败', 'error');
        this.exportFileInfo = null;
      }
    },
  }
};
</script>

<style scoped>
.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  
}

/* 用户状态：正常 */
.status-normal {
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

/* 用户状态：暂时封禁 */
.status-temp-banned {
  background: #fffbe6;
  color: #faad14;
  border: 1px solid #ffe58f;
}

/* 用户状态：封禁中 */
.status-blacklist {
  background: #fff1f0;
  color: #f5222d;
  border: 1px solid #ffa39e;
  margin-right: 10px;
}

/* 用户状态：永久封禁 */
.status-permanent-banned {
  background: #f5f5f5;
  color: #999;
  border: 1px solid #d9d9d9;
}

.btn-edit {
  background: #1890ff;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}

.btn-delete {
  background: #9b9b97;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}

.btn-enable {
  background: #52c41a;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}
.btn-disable {
  background: #fa8c16;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}

.btn-add-blacklist {
  background: #f5222d;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}

.btn-disable:hover {
  background: #d48806;
}
.btn-enable:hover {
  background: #41a017;
}


.btn-edit:hover {
  background: #40a9ff;
}

.btn-delete:hover {
  background: #ff7875;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 600px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e8e8e8;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #666;
}

.modal-body {
  padding: 24px;
}

.modal-footer {
  padding: 10px 24px;
  border-top: 1px solid #e8e8e8;
  text-align: right;
}

.user-form {
  width: 100%;
}

.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.form-group {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 4px;
  font-weight: 500;
  color: #333;
}

.form-group input,
.form-group select {
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.btn-cancel {
  background: #f5f5f5;
  color: #333;
  border: 1px solid #d9d9d9;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 8px;
}

.btn-confirm {
  background: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-cancel:hover {
  background: #e8e8e8;
}

.btn-confirm:hover {
  background: #40a9ff;
}

.change-summary {
  margin-top: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 4px;
}

.change-summary h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #333;
}

.change-summary ul {
  margin: 0;
  padding-left: 20px;
}

.change-summary li {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
}
</style>